export default __webpack_public_path__ + "static/media/Discover.14b3150e.svg";